/**
 * Theme toggle — the field PWA defaults to dark mode (most field techs
 * use the app in cabs / overcast / at dusk). A manual toggle in Settings
 * persists the user's choice to localStorage and applies a
 * `data-theme="light"` attribute on <html> so a few CSS variables can
 * flip via `index.css`. We intentionally don't auto-detect
 * prefers-color-scheme — the OS default doesn't always reflect the
 * field environment.
 */

const STORAGE_KEY = 'argos_field_theme';
type Theme = 'dark' | 'light';

export function getInitialTheme(): Theme {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'light' || stored === 'dark') return stored;
  } catch {/* ignore */}
  return 'dark';
}

export function applyTheme(theme: Theme): void {
  if (typeof document === 'undefined') return;
  document.documentElement.setAttribute('data-theme', theme);
  // Theme color in <meta> tag drives the iOS status-bar tint when
  // the PWA is in standalone mode. Match the body background.
  const tag = document.querySelector('meta[name="theme-color"]');
  if (tag) tag.setAttribute('content', theme === 'light' ? '#ffffff' : '#0b1220');
}

export function setTheme(theme: Theme): void {
  try { localStorage.setItem(STORAGE_KEY, theme); } catch {/* ignore */}
  applyTheme(theme);
}

export function toggleTheme(): Theme {
  const next: Theme = getInitialTheme() === 'dark' ? 'light' : 'dark';
  setTheme(next);
  return next;
}
